import { render, staticRenderFns } from "./labelChangeRecord.vue?vue&type=template&id=72f7d635&scoped=true"
import script from "./labelChangeRecord.vue?vue&type=script&lang=js"
export * from "./labelChangeRecord.vue?vue&type=script&lang=js"
import style0 from "./labelChangeRecord.vue?vue&type=style&index=0&id=72f7d635&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f7d635",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f7d635')) {
      api.createRecord('72f7d635', component.options)
    } else {
      api.reload('72f7d635', component.options)
    }
    module.hot.accept("./labelChangeRecord.vue?vue&type=template&id=72f7d635&scoped=true", function () {
      api.rerender('72f7d635', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LabelGroup/labelChangeRecord.vue"
export default component.exports